import { render, staticRenderFns } from "./OfflineMessageComponent.vue?vue&type=template&id=54559c38&scoped=true"
import script from "./OfflineMessageComponent.vue?vue&type=script&lang=js"
export * from "./OfflineMessageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54559c38",
  null
  
)

export default component.exports